import React from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  if (!product) return null;

  return (
    <div className="card product-card h-100 shadow-sm">
      <div className="position-relative overflow-hidden">
        <div className="product-img-wrapper">
          {product.image ? (
            <img 
              src={product.image} 
              alt={`Işıltı Saz Evi ${product.name} - Kaliteli Müzik Enstrümanı`}
              className="card-img-top product-img"
              loading="lazy"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div 
            className="product-no-img"
            style={{ display: product.image ? 'none' : 'flex' }}
          >
            <div className="text-center">
              <i className="bi bi-image fs-1 text-muted mb-2"></i>
              <p className="text-muted small mb-0">Resim Yok</p>
            </div>
          </div>
        </div>
        
        {product.is_featured && (
          <div className="position-absolute top-0 end-0 m-3">
            <span className="badge bg-primary px-3 py-2 rounded-pill">
              <i className="bi bi-star-fill me-1"></i>
              Öne Çıkan
            </span>
          </div>
        )}
      </div>
      
      <div className="card-body d-flex flex-column p-4">
        <h5 className="card-title fw-bold mb-3" style={{color: '#2d3748'}}>{product.name}</h5>
        
        {product.description && (
          <p className="card-text text-muted small flex-grow-1 mb-3" style={{lineHeight: '1.5'}}>
            {product.description.length > 80 
              ? `${product.description.substring(0, 80)}...` 
              : product.description
            }
          </p>
        )}
        
        <div className="mt-auto">
          <div className="d-flex justify-content-between align-items-center mb-3">
            {product.category_name && (
              <span className="badge bg-light text-dark border">
                <i className="bi bi-tag me-1"></i>
                {product.category_name}
              </span>
            )}
          </div>
          
          <div className="d-grid gap-2">
            <Link 
              to={`/product/${product.id}`} 
              className="btn btn-primary"
            >
              <i className="bi bi-eye me-2"></i>
              Detayları Gör
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
